import { render, staticRenderFns } from "./newsCard.vue?vue&type=template&id=f150a936&scoped=true&"
import script from "./newsCard.vue?vue&type=script&lang=js&"
export * from "./newsCard.vue?vue&type=script&lang=js&"
import style0 from "./newsCard.vue?vue&type=style&index=0&id=f150a936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f150a936",
  null
  
)

export default component.exports